// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1x-0";
export var spinnerContainer = "_1x-1";